import styled from 'styled-components';
import 'styled-system';
import TextBase from './textBase.js';
import 'react-responsive';
import { mobile } from '../../styles/breakpoints.js';
var H4 = /*#__PURE__*/styled(TextBase).attrs(function (_ref) {
  var _theme$typographies, _theme$typographies$h, _theme$colors;

  var fontWeight = _ref.fontWeight,
      color = _ref.color,
      theme = _ref.theme;
  return {
    as: 'h4',
    fontSize: '1.25rem',
    fontWeight: fontWeight || (theme === null || theme === void 0 ? void 0 : (_theme$typographies = theme.typographies) === null || _theme$typographies === void 0 ? void 0 : (_theme$typographies$h = _theme$typographies.h4) === null || _theme$typographies$h === void 0 ? void 0 : _theme$typographies$h.font_weight) || 600,
    lineHeight: '1.75rem',
    color: color || (theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.text),
    letterSpacing: '-0.4px'
  };
}).withConfig({
  displayName: "h4__H4",
  componentId: "sc-1h78j8z-0"
})(["@media ", "{font-size:1.125rem;line-height:1.5rem;}"], mobile);
export default H4;
export { H4 };